import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';
import { Select } from 'antd';
import { DatePicker, Space, Button } from 'antd';
import React, { useState } from 'react';
import axios from 'axios';
import IframeResizer from 'iframe-resizer-react'

const dateFormat = 'YYYY/MM/DD';
const { Column, ColumnGroup } = Table;
const { Option } = Select;

const Reports: React.FC = (props: any) => {
const { name } = useParams<{ name: string; }>();
const [data, SetData] = useState([]);
useIonViewDidEnter(() => {

  // const { fromNotifications } = props.location.state;

  axios.get('https://dev.northroom.co.za/api/bizprop/ammenities/all')
      .then(function (response) {
          // handle success
          console.log(response);
          SetData(response.data);
      })
      .catch(function (error) {
          // handle error
          console.log(error);
      })
      .then(function () {
          // always executed
      });



});

const handleChange = (value: any, record: any) => {
  console.log(`selected ${value}`);


  axios({
      method: 'post',
      url: '/user/12345',
      data: {
          id: record.id,
          Status: record.Status
      }
  }).then(() => {


      axios.get('https://dev.northroom.co.za/api/bizprop/ammenities/all')
          .then(function (response) {
              // handle success
              console.log(response);
              SetData(response.data);
          })
          .catch(function (error) {
              // handle error
              console.log(error);
          })
          .then(function () {
              // always executed
          });


  });

}

return (
  <IonPage>
      <IonHeader>
          <IonToolbar>
              <IonButtons slot="start">
                  <IonMenuButton />
              </IonButtons>
              <IonRow>
                  <PageHeader
                      className="site-page-header"
                      onBack={()=>{props.history.goBack()}}
                      title="Reports"
                  />
              </IonRow>
          </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
          <IonHeader collapse="condense">
              <IonToolbar>
                  <IonTitle size="large">{name}</IonTitle>
              </IonToolbar>
          </IonHeader>
          <Space direction="vertical">
              <IonGrid>
                  <IonRow>
                      <IonCol size="24" style={{ paddingLeft: "40px" }}>
                        




                      </IonCol>
                  </IonRow>
              </IonGrid>
          </Space>
      </IonContent>
  </IonPage>


);
};

export default Reports;

